export const countryIsoCodes = ['CA', 'IE', 'GB', 'US'] as const

export type CountryIsoCode = (typeof countryIsoCodes)[number]
